export const RouteType = {
    COVID: 'COVID',
    NON_COVID: 'NON_COVID',
};

export type TRouteType = typeof RouteType[keyof typeof RouteType];
